import { Ionicons } from '@expo/vector-icons'
import { Pressable, View } from 'react-native'

import { P } from '../ui/typography'
import { CrewAvailability } from '../types/CrewAvailability'
import { availabilityColors, getAvailabilityLabel, getAvailabilityStatus } from './availability-colors'
import { formatLondonStamp, londonDayKey } from '@/lib/availability-dates'

type Availability = CrewAvailability[0]

interface AvailabilityCardProps {
  availability: Availability
  onPress: (availability: Availability) => void
}

/**
 * One period, in the crew member's own terms. Rendered once per period covering the selected day —
 * the screen used to show only the first match, so a day with several overlapping requests looked
 * like a day with one, and the duplicates were invisible from the app.
 */
export function AvailabilityCard({ availability, onPress }: AvailabilityCardProps) {
  const status = getAvailabilityStatus(availability)
  const iconColor = status === 'available' ? 'black' : 'white'

  // Always Europe/London, so the card agrees with the office and with the crew member's shifts
  // whatever their phone is set to.
  const from = availability.from_date
  const to = availability.to_date
  const range = availability.all_day
    ? `${londonDayKey(from).split('-').reverse().join('/')} – ${londonDayKey(to).split('-').reverse().join('/')} (all day)`
    : `${formatLondonStamp(from)} – ${formatLondonStamp(to)}`

  return (
    <Pressable onPress={() => onPress(availability)}>
      <View style={[{ padding: 16 }, { backgroundColor: availabilityColors[status] }]}>
        <View className="flex-row justify-between items-center">
          <View className="flex-1 pr-2">
            <P className="font-bold mb-1 text-white">{getAvailabilityLabel(availability)}</P>
            <P className="text-white">{range}</P>
          </View>
          <Ionicons name="create" size={20} color={iconColor} />
        </View>
      </View>
    </Pressable>
  )
}
